"use client";

import * as Sentry from "@sentry/nextjs";
import { Button } from "@tracify/ui/button";
import Image from "next/image";
import Link from "next/link";
import { useEffect } from "react";

type GlobalErrorProps = {
  error: Error & { digest?: string };
  reset: () => void;
};

export default function GlobalError({ error, reset }: GlobalErrorProps) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="en" className="dark">
      <body className="loading bg-background font-sans">
        <main className="flex min-h-svh items-center justify-center px-6 py-16 text-foreground">
          <div className="flex max-w-md flex-col items-center text-center">
            <Image
              width={166}
              height={28}
              alt="Tracify"
              src="/ICON__TEXT_white.webp"
              priority
            />
            <p className="mt-12 text-sm font-semibold uppercase tracking-wider text-muted-foreground">
              Unexpected error
            </p>
            <h1 className="mt-3 text-3xl font-semibold tracking-tight">
              Something went wrong
            </h1>
            <p className="mt-4 text-sm leading-6 text-muted-foreground">
              The error has been reported. Try loading this view again or return
              to the dashboard.
            </p>
            <div className="mt-8 flex flex-wrap justify-center gap-3">
              <Button onClick={reset}>Try again</Button>
              <Button variant="outline" asChild>
                <Link href="/">Back to dashboard</Link>
              </Button>
            </div>
          </div>
        </main>
      </body>
    </html>
  );
}
